import { render, staticRenderFns } from "./leagueFixed.vue?vue&type=template&id=ca266c74&scoped=true"
import script from "./leagueFixed.vue?vue&type=script&lang=js"
export * from "./leagueFixed.vue?vue&type=script&lang=js"
import style0 from "./leagueFixed.vue?vue&type=style&index=0&id=ca266c74&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca266c74",
  null
  
)

export default component.exports